// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"AlertIcon_ProseMirror__13g6r","alertIcon":"AlertIcon_alertIcon__2DQdE"};